import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

export const useOnLocationChange = (callback: (newLocation: string) => void) => {
  const location = useLocation();
  const locationString = location.pathname + location.search;
  const [initialLocation, setInitialLocation] = useState(locationString);
  useEffect(() => {
    if (initialLocation !== locationString) {
      callback(locationString);
      setInitialLocation(locationString);
    }
  }, [callback, initialLocation, locationString]);
};
